import React, { useState } from 'react';
import {
  Button,
  Chip,
  Collapse,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  Icon,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';


const DataMappingFilterDrawer = ({
  openFilterDrawer,
  setOpenFilterDrawer,
  setFilters,
  filters,
  search
}) => {
  const {searchField} = search;
  const [expandedSku, toggleExpandedSku] = useState(false);
  const [expandedBrand, toggleExpandedBrand] = useState(false);
  const [expandedRevenueCategory1, toggleExpandedRevenueCategory1] = useState(false);
  const [expandedRevenueCategory2, toggleExpandedRevenueCategory2] = useState(false);

  const [conditions, setConditions] = useState(filters);


  const handleChangeFilter = ({target: {value, name}}) => {
    setConditions((conditions) => (
      {
        ...conditions,
        [name]: value
      }
    ));
  };

  const handleApplyFilter = (conditions) => {
    setFilters(conditions);
    setOpenFilterDrawer(false);
  };

  return (
    <Drawer
      anchor="right"
      open={openFilterDrawer}
      onClose={() => setOpenFilterDrawer((openFilterDrawer) => !openFilterDrawer)}
      PaperProps={{ style: { maxWidth: '400px' } }}
    >
      <div className="px-4 pt-4 min-h-full-screen flex-column justify-between">
        <div>
          <div className="flex items-center justify-between mb-2">
            <Typography variant="h5" className="text-primary uppercase">Filter by:</Typography>
            <IconButton onClick={() => setOpenFilterDrawer(false)}>
              <Icon fontSize="small">close</Icon>
            </IconButton>
          </div>
          <div className="flex items-center flex-wrap mb-2">
            {Object.keys(conditions).map((filterName, index) => {
              if (!conditions?.[filterName]) {
                return null;
              }

              let label = conditions[filterName];

              if (filterName === 'product_sku') {
                label = conditions[filterName] == 'Ignore' ? 'Show Ignore' : 'Hide Ignore';
              }

              return (
                <div key={`filter-${index}`} className="mr-2 mb-2 capitalize">
                  <Chip
                    label={label}
                    onDelete={() => {
                      const {[filterName as keyof typeof conditions]: _, ...restFilters} = conditions;
                      setConditions(restFilters);
                    }}
                  />
                </div>
              );
            })}
          </div>
          {searchField !== 'product_sku' && //hide already filter through API fields to avoid wrong response
          <>
            <div
              className="flex items-center justify-between cursor-pointer"
              onClick={() => toggleExpandedSku((expandedSku) => !expandedSku)}
            >
              <Typography variant="h6">SKU / Ignore</Typography>
              {expandedSku ? <ExpandLess /> : <ExpandMore />}
            </div>
            <Collapse in={expandedSku} timeout="auto">
              <FormControl component="div">
                <RadioGroup
                  aria-label="product_sku"
                  name="product_sku"
                  value={conditions?.product_sku || ''}
                  onChange={handleChangeFilter}
                >
                  <FormControlLabel
                    value="sku"
                    control={<Radio color="primary" size="small" />}
                    label="Hide Ignore"
                  />
                  <FormControlLabel
                    value="Ignore"
                    control={<Radio color="primary" size="small" />}
                    label="Show Ignore"
                  />
                </RadioGroup>
              </FormControl>
            </Collapse>
            <Divider className="my-5" />
          </>
          }
          {searchField !== 'product_brand' &&
          <>
            <div
              className="flex items-center justify-between cursor-pointer"
              onClick={() => toggleExpandedBrand((expandedBrand) => !expandedBrand)}
            >
              <Typography variant="h6">Brand</Typography>
              {expandedBrand ? <ExpandLess /> : <ExpandMore />}
            </div>
            <Collapse in={expandedBrand} timeout="auto">
              <TextField
                fullWidth
                variant="outlined"
                className="my-5"
                name="product_brand"
                label="Brand"
                value={conditions?.product_brand || ''}
                onChange={handleChangeFilter}
              />
            </Collapse>
            <Divider className="my-5" />
          </>
          }
          {searchField !== 'product_category1' &&
          <>
            <div
              className="flex items-center justify-between cursor-pointer"
              onClick={() => toggleExpandedRevenueCategory1((expandedRevenueCategory1) => !expandedRevenueCategory1)}
            >
              <Typography variant="h6">Revenue Category 1</Typography>
              {expandedRevenueCategory1 ? <ExpandLess /> : <ExpandMore />}
            </div>
            <Collapse in={expandedRevenueCategory1} timeout="auto">
              <TextField
                fullWidth
                variant="outlined"
                className="my-5"
                name="product_category1"
                label="Revenue Category 1"
                value={conditions?.product_category1 || ''}
                onChange={handleChangeFilter}
              />
            </Collapse>
            <Divider className="my-5" />
          </>
          }
          {searchField !== 'product_category2' &&
          <>
            <div
              className="flex items-center justify-between cursor-pointer"
              onClick={() => toggleExpandedRevenueCategory2((expandedRevenueCategory2) => !expandedRevenueCategory2)}
            >
              <Typography variant="h6">Revenue Category 2</Typography>
              {expandedRevenueCategory2 ? <ExpandLess /> : <ExpandMore />}
            </div>
            <Collapse in={expandedRevenueCategory2} timeout="auto">
              <TextField
                fullWidth
                variant="outlined"
                className="my-5"
                name="product_category2"
                label="Revenue Category 2"
                value={conditions?.product_category2 || ''}
                onChange={handleChangeFilter}
              />
            </Collapse>
            <Divider className="my-5" />
          </>
          }
        </div>
        <div className="flex items-center justify-between pb-4">
          <Button
            variant="contained"
            color="primary"
            fullWidth
            className="mr-2 uppercase"
            onClick={() => handleApplyFilter(conditions)}
          >
            Apply Filters
          </Button>
          <Button
            variant="outlined"
            fullWidth
            className="uppercase"
            onClick={() => {
              setConditions(() => ({}));
              handleApplyFilter({});
              setOpenFilterDrawer(false);
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default DataMappingFilterDrawer;
